/**
 * Splits a sentence into its first word and the rest of the sentence.
 *
 * @param sentence - The input sentence to be split.
 * @returns An object containing two properties:
 *   - first: The first word of the sentence.
 *   - rest: The remainder of the sentence (all words after the first).
 */
export const getFirstAndRest = (sentence: string) => {
  const _sentence = sentence.trim()
  const words = _sentence.split(' ')
  for (let i = 0; i < words.length; i++) {
    if (words[i]) {
      const first = words[i]
      const rest = words.slice(i + 1).join(' ')
      return { first, rest }
    }
  }

  return { first: '', rest: '' }
}
